import { ItemAttachment } from './itemAttachment'

import type { LocalAttachment } from './workflowAttachment'

type TableAttachmentProps = {
  attachments: LocalAttachment[]
  onRemoveAttachment: (index: number) => void
}

export function TableAttachment({
  attachments,
  onRemoveAttachment,
}: TableAttachmentProps) {
  return (
    <div className="w-full overflow-hidden rounded-lg border border-system-border-primary">
      <div className="grid grid-cols-[4fr_0.8fr_2fr_1.5fr_2rem] gap-4 border-b border-system-border-primary px-4 py-3">
        <div className="text-sm font-medium text-system-text-secondary">
          Nome
        </div>
        <div className="text-sm font-medium text-system-text-secondary">
          Tamanho
        </div>
        <div className="text-sm font-medium text-system-text-secondary">
          Data
        </div>
        <div className="text-sm font-medium text-system-text-secondary">
          Autor
        </div>
        <div className="w-8 min-w-0" />
      </div>

      <div className="divide-y divide-system-border-primary">
        {attachments.length > 0 &&
          attachments.map((attachment, index) => (
            <ItemAttachment
              key={attachment.file?.name ?? attachment.preview ?? index}
              attachment={attachment}
              onRemove={() => onRemoveAttachment(index)}
            />
          ))}

        {attachments.length === 0 && (
          <div className="flex items-center justify-center px-4 py-3">
            <span className="text-sm text-system-text-secondary">
              Nenhum anexo encontrado para esta etapa
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
